import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SYNC_STATUS: `${cleanedFilename(__filename)}-sync-status`,
};
